import { jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { TARGET_BLANK } from "../../../constants/href";
import Text from "../Text";
import { renderArrow } from "./Link.shared";
const ExternalLink = ({ children, arrow, ...linkProps }) => {
    const withArrowCx = cx(linkProps.className, {
        "items-start gap-1 inline-flex": arrow,
    });
    return (_jsxs(Text, { ...TARGET_BLANK, ...linkProps, hoverable: linkProps.hoverable ?? true, className: cx(withArrowCx, "group no-underline"), tag: "a", children: [children, renderArrow(arrow, linkProps.size)] }));
};
export default ExternalLink;
//# sourceMappingURL=ExternalLink.js.map